import { setupImageHeightWidthByContainer } from "../../utils/billing";

export const anketaToFormData = (obj: any, form?: any, namespace?: any) => {
  const formData = form || new FormData();
  for (const property in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, property)) {
      const formKey = namespace ? `${namespace}[${property}]` : property;
      if (obj[property] instanceof File) {
        formData.append(formKey, obj[property] as Blob);
      } else if (Array.isArray(obj[property])) {
        obj[property].forEach((element: any, index: any) => {
          const tempFormKey = `${formKey}[${index}]`;
          if (typeof element === "object" && !(element instanceof File)) {
            anketaToFormData(element, formData, tempFormKey);
          } else {
            formData.append(tempFormKey, element);
          }
        });
      } else if (
        typeof obj[property] === "object" &&
        !(obj[property] instanceof File)
      ) {
        anketaToFormData(obj[property], formData, formKey);
      } else {
        formData.append(formKey, obj[property]);
      }
    }
  }

  return formData;
};

export const createFileFromImage = async (imageSrc: string, fileName: string) => {
  try {
    const response = await fetch(imageSrc);
    const blob = await response.blob();
    const file = new File([blob], fileName, { type: blob.type });
    console.log("File создан:", file);
    return file;
  } catch (error) {
    console.error("Ошибка при создании File:", error);
  }
};

export const getImageDimensions = (
  imageSrc: string
): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.width, height: img.height });
    img.onerror = reject;
    img.src = imageSrc;
  });
};

export const getCustomImageSize = (imageWidth: number, imageHeight: number) => {
  let cWidth: number;
  let cHeight: number;
  const cDiff = imageWidth - imageWidth;
  if (cDiff === 0) {
    cWidth = 300;
    cHeight = 300;
  } else if (cDiff > 0) {
    cWidth = 400;
    cHeight = 300;
  } else {
    cWidth = 400;
    cHeight = 600;
  }

  const { width, height } = setupImageHeightWidthByContainer(
    cWidth,
    cHeight,
    imageWidth,
    imageHeight
  );

  return {
    width: width ? Math.ceil(width / 10) * 10 : 0,
    height: height ? Math.ceil(height / 10) * 10 : 0,
  };
};
